import { Button } from "@/components/button"
import type { SwapFallbackMode } from "@/domains/swap-aggregators/types"

import type { SwapAggregator } from "./composables/swap-settings-sections/swap-aggregators-section"
import { SwapAggregatorsSection } from "./composables/swap-settings-sections/swap-aggregators-section"
import { SwapSlippageSection } from "./composables/swap-settings-sections/swap-slippage-section"
import { SwapDialog } from "./swap-dialog"

export const SwapSettingsDialog: React.FC<{
  isOpen: boolean
  onClose: () => void
  aggregators: Array<SwapAggregator>
  fallbackMode: SwapFallbackMode
  slippage: string
  onFallbackAggregatorSelect: (aggregatorId: string) => void
  onFallbackModeChange: (mode: SwapFallbackMode) => void
  onSlippageChanged: (slippage: string) => void
}> = ({
  isOpen,
  onClose,
  aggregators,
  fallbackMode,
  slippage,
  onFallbackAggregatorSelect,
  onFallbackModeChange,
  onSlippageChanged,
}) => {
  return (
    <SwapDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Swap Settings"
      description="Choose the external provider and slippage tolerance for swaps."
    >
      <div className="flex max-h-[calc(100vh-4rem)] flex-col overflow-y-auto">
        <div className="space-y-8">
          <SwapAggregatorsSection
            aggregators={aggregators}
            fallbackMode={fallbackMode}
            onFallbackAggregatorSelect={onFallbackAggregatorSelect}
            onFallbackModeChange={onFallbackModeChange}
          />
          <SwapSlippageSection slippage={slippage} onSlippageChanged={onSlippageChanged} />
          <div className="mt-4 flex justify-end">
            <Button variant={"primary"} size="md" onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </SwapDialog>
  )
}
